module.exports = __webpack_public_path__ + "img/sj.db071a63.jpg";